export default {
      id: "check-usage",
      viewBox: "0 0 9 8",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#check",
      toString: function () {
        return this.url;
      }
    }